import React, { forwardRef } from 'react';
import { Form, FloatingLabel } from "react-bootstrap";

export const TextInput = forwardRef(({
  name,
  label,
  hint = null,
  error = null,
  field = null,
  register = null,
  noFloating = false,
  ...props
}, ref) => {
  let inputProps = {};
  if (field) {
    inputProps = field;
  } else if (register) {
    const { ref: registerRef, ...rest } = register(name);
    inputProps = {
      ...rest,
      ref: (e) => {
        registerRef(e);
        if (ref) {
          if (typeof ref === 'function') ref(e);
          else ref.current = e;
        }
      }
    };
  } else {
    inputProps = { ref };
  }

  const input = (
    <Form.Control
      {...inputProps}
      className={`form-control rounded-3 ${props.className || ''}`}
      size="md"
      placeholder={label}
      type={props.type || "text"}
      autoComplete="on"
      {...props}
    />
  );

  return (
    <div className="mb-2">
      {!noFloating ? (
        <FloatingLabel controlId={`floating${name}`} label={label}>
          {input}
        </FloatingLabel>
      ) : (
        input
      )}
      {error && <div className="text-danger small mt-1 fw-bold">{error}</div>}
      {hint && !error && <div className="text-muted small mt-1">{hint}</div>}
    </div>
  );
});

export const SelectInput = forwardRef(({
  name,
  label,
  error = null,
  hint = null,
  register,
  value,
  onChange,
  onBlur,
  noFloating = false,
  ...props
}, ref) => {
  let selectProps = {};
  if (register) {
    const { ref: registerRef, ...rest } = register(name);
    selectProps = {
      ...rest,
      ref: (e) => {
        registerRef(e);
        if (ref) {
          if (typeof ref === 'function') ref(e);
          else ref.current = e;
        }
      }
    };
  } else {
    selectProps = {
      name,
      value,
      onChange,
      onBlur,
      ref,
    };
  }

  const select = (
    <Form.Select
      className={`form-control form-control-md rounded-3 ${props.className || ''}`}
      size="md"
      {...selectProps}
      {...props}
    />
  );

  return (
    <div className="mb-2">
      {!noFloating ? (
        <FloatingLabel controlId={`floating${name}`} label={label}>
          {select}
        </FloatingLabel>
      ) : (
        select
      )}
      {error && <div className="text-danger small mt-1 fw-bold">{error}</div>}
      {hint && !error && <div className="text-muted small mt-1">{hint}</div>}
    </div>
  );
});

